import { render, staticRenderFns } from "./finalScreenRank.vue?vue&type=template&id=c2314b04&scoped=true&"
import script from "./finalScreenRank.vue?vue&type=script&lang=js&"
export * from "./finalScreenRank.vue?vue&type=script&lang=js&"
import style0 from "./finalScreenRank.vue?vue&type=style&index=0&id=c2314b04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2314b04",
  null
  
)

export default component.exports